/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import ViewVisitGuide from "./view-visit-guide";
import "react-quill/dist/quill.snow.css";
import "quill-image-uploader/dist/quill.imageUploader.min.css";
import { EditVisitGuide } from "./edit-visit-guide";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";
import { encrypt } from "utils/crypto";
import { gaEvent } from "utils/ga-utils";
import Root from "pages/root";
import { Heading, Container } from "./uis";
import UI from "@mile-meeting/mile-ui";
import {
  getKakaoAlimTalkContent,
  TKakaoAlimContent,
  updateKakaoAlimTalkContent,
} from "apis/visitors/setting/kakao-alimtalk";

export const VisitGuideManage = () => {
  const workspaceInfo = useRecoilValue(workspace);
  const [isEditing, setIsEditing] = useState(false);
  const [data, setData] = useState<TKakaoAlimContent>({
    address: "",
    addressForMap: "",
    directionsHtmlInKoreanFormat: "",
    additionalInfosHtmlInKoreanFormat: "",
    directionsHtmlInEnglishFormat: "",
    additionalInfosHtmlInEnglishFormat: "",
  });

  useEffect(() => {
    getKakaoAlimTalkContent().then((res) => {
      if (res.success && res.data) setData(res.data);
    });
  }, []);

  return (
    <Container>
      <Heading>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 0 24px 20px",
          }}
        >
          방문 안내 메시지 관리
        </UI.Typography>
        <UI.Button
          onClick={async () => {
            if (isEditing) {
              const res = await updateKakaoAlimTalkContent(data);
              if (res.success) window.location.reload();
            } else setIsEditing(!isEditing);
          }}
          title={isEditing ? "저장하기" : "수정하기"}
          style={{ marginLeft: "auto" }}
        />
        {!isEditing && (
          <UI.Button
            primary={false}
            onClick={async () => {
              if (workspaceInfo?.id) {
                window.open(
                  `${process.env.REACT_APP_VISITORS_WEB_URL}/default/${encodeURIComponent(encrypt(workspaceInfo.id))}`
                );
              }
              gaEvent("방문 안내 메세지 관리 - 프리뷰 선택");
            }}
            title="프리뷰"
          />
        )}
      </Heading>
      {isEditing === false ? <ViewVisitGuide data={data} /> : <EditVisitGuide data={data} setData={setData} />}
    </Container>
  );
};

export default VisitGuideManage;
